import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_USER } from '@/util/roles';

export const routes = [
	{
		path: 'review/:review_uuid',
		meta: {
			requireAuth: true,
			breadcrumb: 'Review',
			// A sibling of the reviews section rather than a child, so it inherits
			// nothing from it and must be opened separately. Every row of the
			// all-reviews table links here; without this they all hit Forbidden.
			minRole: ROLE_USER,
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.REVIEW.VIEW_REVIEW,
				component: () => {
					return import('@/views/depot/review/View-Review.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
		],
	},
];
